import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from '@/pages/Dashboard';
import MeineTermine from '@/pages/MeineTermine';
import { Toaster } from '@/components/ui/sonner';
import { PasswordGate } from '@/components/PasswordGate';

function App() {
  return (
    <div className="App">
      <PasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/termine" element={<MeineTermine />} />
          </Routes>
        </BrowserRouter>
      </PasswordGate>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;